<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="0px">
        <h3>会员等级设置</h3>                  
        <el-form-item prop="one_number">
            <div style="display: flex;align-items: center;">
                <div>成功推广</div>
                <el-col :span="2"><el-input v-model="editForm.one_number" controls-position="right" :min="0"
                                   class="ele-fluid ele-text-left"></el-input></el-col>
                <div>
                    人升级为
                </div>
                <el-col :span="3"><el-input v-model="editForm.one_title" controls-position="right" :min="0"
                                   class="ele-fluid ele-text-left"></el-input></el-col>
            </div>
            
        </el-form-item>
                                                      
        <el-form-item  prop="two_number">
            <div style="display: flex;align-items: center;">
                <div>成功推广</div>
                <el-col :span="2">
                    <el-input v-model="editForm.two_number" controls-position="right" :min="0"
                                      class="ele-fluid ele-text-left"/>
                </el-col>
                <div>
                    人升级为
                </div>
                <el-col :span="3"><el-input v-model="editForm.two_title" controls-position="right" :min="0"
                                   class="ele-fluid ele-text-left"></el-input></el-col>
            </div>
        </el-form-item>
                                                      
        <el-form-item prop="three_number">
            <div style="display: flex;align-items: center;">
                <div>成功推广</div>
                <el-col :span="2">
                    <el-input v-model="editForm.three_number" controls-position="right" :min="0"
                                      class="ele-fluid ele-text-left"/>
                </el-col>
                <div>
                    人升级为
                </div>
                <el-col :span="3"><el-input v-model="editForm.three_title" controls-position="right" :min="0"
                                   class="ele-fluid ele-text-left"></el-input></el-col>
            </div>
        </el-form-item>
        <h3>子会员分润设置</h3>                                  
        <el-form-item prop="one_price">
            <div style="display: flex;align-items: center;">
                <div>一级子会员单笔订单消费额</div>
                <el-col :span="2">
                    <el-input v-model="editForm.one_price" controls-position="right" :min="0"
                                       class="ele-fluid ele-text-left"/>
                </el-col>
                <div>
                    %
                </div>
            </div>
        </el-form-item>
                                                      
        <el-form-item prop="two_price">
            <div style="display: flex;align-items: center;">
                <div>二级子会员单笔订单消费额</div>
                <el-col :span="2">
                    <el-input v-model="editForm.two_price" controls-position="right" :min="0"
                                      class="ele-fluid ele-text-left"/>
                </el-col>
                <div>
                    %
                </div>
            </div>
        </el-form-item>
        <el-form-item >
           <el-button type="primary" @click="save">保存</el-button>
        </el-form-item>
      </el-form>
      
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SysUserGrade",
  data() {
    return {
      table: {url: '/usergrade/index', where: {}},  // 表格配置
      choose: [],  // 表格选中数据
      showEdit: false,  // 是否显示表单弹窗
      editForm: {},  // 表单数据
      editRules: {  // 表单验证规则
              
        one_number: [
          {required: true, message: '请输入一星会员人数', trigger: 'blur'}
        ],
                          
        two_number: [
          {required: true, message: '请输入二星会员人数', trigger: 'blur'}
        ],
                          
        three_number: [
          {required: true, message: '请输入三星会员人数', trigger: 'blur'}
        ],
                          
        one_price: [
          {required: true, message: '请输入一级会员单笔消费返佣', trigger: 'blur'}
        ],
                          
        two_price: [
          {required: true, message: '请输入二级会员单笔消费返佣', trigger: 'blur'}
        ],
              
      },
    }
  },
computed: {
    ...mapGetters(["permission"]),
},
  mounted() {
      this.edit();
  },
  methods: {
    /**
     * 显示编辑
     */
    edit() {
      this.$http.get('/usergrade/info?id=1').then(res => {
        if (res.data.code === 0) {
          this.editForm = res.data.data;
          this.showEdit = true;
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      });
    },
    /**
     * 保存编辑
     */
    save() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          const loading = this.$loading({lock: true});
          this.$http.post('/usergrade/edit', this.editForm).then(res => {
            loading.close();
            if (res.data.code === 0) {
              this.showEdit = false;
              this.$message({type: 'success', message: res.data.msg||'保存成功'});
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            loading.close();
            this.$message.error(e.message);
          });
        } else {
          return false;
        }
      });
    },
    /**
     * 刪除(批量刪除)
     */
    remove(row) {
      console.log(row)
      if (!row) {  // 批量删除
        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
        let ids = this.choose.map(d => d.id);
        this.$confirm('确定要删除选中的会员设置吗?', '提示', {type: 'warning'}).then(() => {
          const loading = this.$loading({lock: true});
          this.$http.post('/usergrade/delete', {id: ids}).then(res => {
            loading.close();
            if (res.data.code === 0) {
              this.$message({type: 'success', message: res.data.msg});
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e => {
            loading.close();
            this.$message.error(e.message);
          });
        }).catch(() => 0);
      } else {  // 单个删除
        const loading = this.$loading({lock: true});
        this.$http.post('/usergrade/delete', {id:row.id}).then(res => {
          loading.close();
          if (res.data.code === 0) {
            this.$message({type: 'success', message: res.data.msg});
            this.$refs.table.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e => {
          loading.close();
          this.$message.error(e.message);
        });
      }
    },
                        }
}
</script>

<style scoped>
.ele-block >>> .el-upload, .ele-block >>> .el-upload-dragger {
  width: 100%;
}
</style>